import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        id: "organization",
        label: <FormattedMessage id="trip.client" />,
        name: "name",
        entityName: "organizations",
        key: "organizationId",
    },
    {
        id: "creator",
        label: <FormattedMessage id="trip.creator" />,
        name: "email",
        entityName: "creator",
        key: "creatorId",
    },
    {
        id: "driver",
        label: <FormattedMessage id="trip.driver" />,
        name: "name",
        key: "driverId",
        entityName: "drivers",
    },
    {
        id: "supplier",
        label: <FormattedMessage id="trip.supplier" />,
        key: "supplierId",
        name: "name",
        entityName: "suppliers",
    },
    {
        id: "truck",
        label: <FormattedMessage id="trip.truck" />,
        name: "plateNumber",
        entityName: "trucks",
        key: "truckId",
    },
    {
        label: <FormattedMessage id="trip.truck-type" />,
        id: "truckType",
        entityName: "truckTypes",
        key: "truckTypeId",
        displayName: "alias",
    },
    {
        label: <FormattedMessage id="trip.status" />,
        id: "status",
    },
];
